export const COMPANY = {
  name: "Bremer Recycling Service",
  short: "BRS",
  phone: "+49 1573 7775391",
  phoneRaw: "+4915737775391",
  whatsappNumber: "4915737775391",
  email: "info@bremer-recycling-service.de",
  instagram: "https://www.instagram.com/bremer_recycling_service",
  instagramHandle: "@bremer_recycling_service",
  area: "Bremen & Umgebung",
  hours: "Mo–So · 07:00 – 22:00 Uhr",
  logo: "https://customer-assets.emergentagent.com/job_5576d3fe-ea52-4b93-a398-ab3153139c10/artifacts/hau5eklf_bild%2012312312231.PNG",
  googleReviewUrl: "https://www.google.de/search?sca_esv=4521476c5740f22a&q=Schrottabholung+%26+Entr%C3%BCmpelung+Bremen+Bremer+Recycling+Service+Rezensionen",
  impressum: {
    address: ["c/o HQ Bremen Airport", "Flughafenallee 26", "28199 Bremen"],
    ceo: "Adil Altun",
    ustId: "DE450657364",
  },
};

export const buildWhatsAppUrl = (message = "") => {
  const text = encodeURIComponent(
    message ||
      "Hallo BRS, ich habe eine Anfrage zur Abholung / Entrümpelung. Bitte melden Sie sich bei mir."
  );
  return `https://wa.me/${COMPANY.whatsappNumber}?text=${text}`;
};

// Real BRS photos (single Vorher/Nachher pair)
export const IMAGES = {
  beforeAfter: {
    id: "garten",
    label: "Garten · Entrümpelung in Bremen",
    days: "Vorher / Nachher · 1 Tag Arbeit + besenrein",
    before:
      "https://customer-assets.emergentagent.com/job_schrott-entsorgt/artifacts/j3kh61og_WhatsApp%20Image%202026-05-20%20at%2000.06.49%20%281%29.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_schrott-entsorgt/artifacts/44s80z0e_WhatsApp%20Image%202026-05-20%20at%2000.06.49.jpeg",
  },
  // Real photos from BRS jobs
  team: {
    vanSide: "https://customer-assets.emergentagent.com/job_schrott-entsorgt/artifacts/n59vakw3_2023-08-30.webp", // van side w/ logo + appliances
    vanRear: "https://customer-assets.emergentagent.com/job_schrott-entsorgt/artifacts/qey84hfm_2024-03-05.webp", // rear view w/ many appliances
    vanLoaded: "https://customer-assets.emergentagent.com/job_schrott-entsorgt/artifacts/e0z2rstq_2024-03-05%20%281%29.webp", // van loaded with scrap
    vanInAction: "https://customer-assets.emergentagent.com/job_schrott-entsorgt/artifacts/mm1o5rl3_2023-08-30%20%281%29.webp", // van at job site moving furniture
  },
};
